module.exports = __webpack_public_path__ + "static/media/alibaba-guide-background.37d3821b.png";